import APIClient from './index';

export const updateUserAnalysis = (analysis, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/UserAnalysis/${analysis.id}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};
